'use strict';
(function () {
  angular.module('pentaApp').factory('router.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/router', null, { query: { isArray: true, cache: true } });
  }
})();